"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
var objective_node_1 = __importDefault(require("../objective_node"));
var react_2 = require("react");
var challenge_1 = require("../../../../../../../reducers/slices/challenge/challenge");
var react_redux_1 = require("react-redux");
var challengeEditorContext_1 = require("../../../../../../../contexts/challengeEditorContext");
var ReferralObjectiveObjectiveNode = function (props) {
    var isReadOnly = (0, challengeEditorContext_1.useChallengeReadOnly)();
    var data = props.data;
    var dispatch = (0, react_redux_1.useDispatch)();
    var setConfigData = function (config) {
        dispatch((0, challenge_1.setNode)(__assign(__assign({}, props), { data: __assign(__assign({}, data), { config: config }) })));
    };
    var configurationComponent = function () {
        var _a, _b, _c, _d;
        return ((0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col gap-2", children: [(0, jsx_runtime_1.jsxs)(react_1.TextField, { isReadOnly: isReadOnly, value: data.config.title, onChange: function (value) { return setConfigData(__assign(__assign({}, data.config), { title: value })); }, children: [(0, jsx_runtime_1.jsx)(react_1.Label, { children: "Title" }), (0, jsx_runtime_1.jsx)(react_1.Input, { maxLength: 120 })] }), (0, jsx_runtime_1.jsxs)(react_1.TextField, { isReadOnly: isReadOnly, value: (_d = (_c = (_b = (_a = data.config) === null || _a === void 0 ? void 0 : _a.trigger) === null || _b === void 0 ? void 0 : _b.trigger_quantity) === null || _c === void 0 ? void 0 : _c.toString()) !== null && _d !== void 0 ? _d : "", onChange: function (value) { return setConfigData(__assign(__assign({}, data.config), { trigger: __assign(__assign({}, data.config.trigger), { trigger_quantity: parseInt(value) }) })); }, children: [(0, jsx_runtime_1.jsx)(react_1.Label, { children: "Trigger Quantity" }), (0, jsx_runtime_1.jsx)(react_1.Input, { type: "number", max: 999 })] })] }));
    };
    return (0, jsx_runtime_1.jsx)(objective_node_1.default, __assign({ data: data }, props, { configurationComponent: configurationComponent }));
};
exports.default = (0, react_2.memo)(ReferralObjectiveObjectiveNode);
